module.exports = __webpack_public_path__ + "img/face_claro.17435793.svg";